import { useTranslation } from "react-i18next";
import ColorInput from "../../../../common/ColorInput";
import FontSelect from "../../../../common/FontSelect";
import NewsSlidePreview from "./NewsSlidePreview";
import Collapse from "../../../../common/Collapse";

export default function NewsSlideSettings({
  styleSettings,
  handleStyleChange,
}) {
  const { t } = useTranslation();

  // Extract slideItem settings with fallbacks
  const slideItem = styleSettings?.slideItem || {};
  const titleSettings = slideItem.title || {};
  const categorySettings = slideItem.category || {};
  const subTitleSettings = slideItem.subTitle || {};

  return (
    <Collapse
      title={
        <div className="font-semibold text-gray-800 text-xl">
          {t("news slide")}
        </div>
      }
      className="mb-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 divide-x divide-gray-400">
        <div className="grid grid-cols-1">
          <div className="px-4">
            <div className="text-lg font-semibold text-gray-700 mb-2">
              {t("title")}
            </div>
            <div className="flex items-center py-4 gap-4">
              <ColorInput
                name="slideItem.title.color"
                label={t("color")}
                value={titleSettings.color || "#000000"}
                onChange={handleStyleChange}
                className="flex-1"
              />
              <FontSelect
                name="slideItem.title.font"
                label={t("font")}
                value={titleSettings.font || ""}
                onChange={handleStyleChange}
                className="flex-1"
              />
              <ColorInput
                name="slideItem.title.backgroundColor"
                label={t("background color")}
                value={titleSettings.backgroundColor || "#ffffff"}
                onChange={handleStyleChange}
                className="flex-1"
              />
            </div>
          </div>

          <div className="px-4">
            <div className="text-lg font-semibold text-gray-700 mb-2">
              {t("category")}
            </div>
            <div className="flex items-stretch py-4 gap-4">
              <ColorInput
                name="slideItem.category.color"
                label={t("color")}
                value={categorySettings.color || "#000000"}
                onChange={handleStyleChange}
                className="flex-1"
              />
              <FontSelect
                name="slideItem.category.font"
                label={t("font")}
                value={categorySettings.font || ""}
                onChange={handleStyleChange}
                className="flex-1"
              />
              <ColorInput
                name="slideItem.category.backgroundColor"
                label={t("background color")}
                value={categorySettings.backgroundColor || "#ffffff"}
                onChange={handleStyleChange}
                className="flex-1"
              />
            </div>
          </div>

          <div className="px-4">
            <div className="text-lg font-semibold text-gray-700 mb-2">
              {t("sub title")}
            </div>
            <div className="flex items-stretch py-4 gap-4">
              <ColorInput
                name="slideItem.subTitle.color"
                label={t("color")}
                value={subTitleSettings.color || "#000000"}
                onChange={handleStyleChange}
                className="flex-1"
              />
              <FontSelect
                name="slideItem.subTitle.font"
                label={t("font")}
                value={subTitleSettings.font || ""}
                onChange={handleStyleChange}
                className="flex-1"
              />
              <ColorInput
                name="slideItem.subTitle.backgroundColor"
                label={t("background color")}
                value={subTitleSettings.backgroundColor || "#ffffff"}
                onChange={handleStyleChange}
                className="flex-1"
              />
            </div>
          </div>
        </div>
        <div className="px-4">
          <div className="text-lg font-semibold text-gray-700 mb-2">
            {t("slide preview")}
          </div>
          {/* Scaled 1920x1080 canvas preview */}
          <NewsSlidePreview
            news={{
              title: t("news title is seen here"),
              category: t("category is seen here"),
              subTitle: t("sub title is seen here"),
              image:
                "https://static.doviz.com/news/tcmb-baskani-karahan-dan-yeni-banknot-ve-asgari-ucret-sorularina-yanit-1762507397.jpg",
            }}
            styleSettings={styleSettings}
          />
        </div>
      </div>
    </Collapse>
  );
}
